import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/utils/filters";
import "@/plugins/icons";
import "./assets/css/index.css";
import i18n from "@/plugins/i18n";

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  mounted() {
    const wrapperElement = document.getElementById("ot-app-wrapper");
    const initialLanguage = wrapperElement.getAttribute("lang") || "en";

    this.$i18n.locale = initialLanguage;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "lang"
        ) {
          const newLanguage = wrapperElement.getAttribute("lang");
          if (newLanguage && newLanguage !== this.$i18n.locale) {
            this.$i18n.locale = newLanguage;
            this.$forceUpdate();
          }
        }
      });
    });

    observer.observe(wrapperElement, { attributes: true });
  },
  render: (h) => h(App),
}).$mount("#app");
